export const subdomainsDir = `/_subdomains`;
